import type { AccessRequestDto, RequestAccessDto } from './dto';
import type { AccessRequest, AccessRequestResponse } from './model';

export const mapRequestAccessDtoToModel = (data: RequestAccessDto): AccessRequestResponse => {
  return {
    email: data?.email,
    success: data?.success,
    organizationId: data?.organization_id,
    organizationName: data?.organization_name,
    accountId: data?.account_id,
  };
};

export const mapAccessRequestModelToDto = (data: AccessRequest): AccessRequestDto => {
  return {
    email: data?.email,
    url: data?.url,
    site_id: data.siteId,
    locale: data?.locale,
  };
};
